/*
 * @Author: YuanYuan
 * @Date: 2024-02-04 19:44:22
 * @LastEditTime: 2024-05-28 18:28:16
 * @Description: 常量构造器
 */
import CONST_CONFIG from './modules'
import { upperFirst } from 'lodash-es'

class ConstMaker {
  constructor (options) {
    this.const = {}
    this.constBuilder(options)
  }

  constBuilder ({ sep, config }) {
    Object.keys(config).forEach(namespace => {
      this._constSingleBuilder({
        namespace,
        sep: sep,
        config: config[namespace]
      })
    })
  }

  _constSingleBuilder ({ namespace, sep, config }) {
    config.forEach(cst => {
      const { name, value } = cst
      const constName = `${upperFirst(namespace)}${sep}${name}`
      Object.defineProperty(this.const, constName, { value })
    })
  }
}

export default new ConstMaker({
  config: CONST_CONFIG,
  sep: '/'
}).const
